/**
 * Keep the pickup line in step with the chosen variant.
 *
 * ⚠️ IT DOES NOTHING UNTIL LOCAL PICKUP IS ENABLED. The mount only exists when the first
 * variant had availabilities, and Shopify's section route answers empty otherwise — so on
 * a shop with pickup off this file finds no mount and returns.
 *
 * ⚠️ ONE REQUEST PER CHANGE, LAST ONE WINS. A customer clicking through sizes fires
 * several; without the token an earlier, slower response can overwrite a later one and
 * the page ends up describing a size nobody is looking at. Same failure the price would
 * have if it were fetched.
 */
(function () {
  var mount = document.querySelector('[data-djh-pickup]');
  if (!mount) return;

  var base = mount.getAttribute('data-url');
  var field = document.querySelector('.djh-product__form [name="id"]');
  if (!base || !field) return;

  var token = 0;

  function refresh() {
    var id = field.value;
    if (!id) return;
    var mine = ++token;

    fetch(base.replace('__ID__', id))
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (mine !== token) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('[data-djh-pickup-body]');
        mount.innerHTML = '';
        if (body) mount.appendChild(body);
      })
      .catch(function () { if (mine === token) mount.innerHTML = ''; });
  }

  field.addEventListener('change', refresh);
})();
